import React from 'react';
import PageHero from '../components/PageHero';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import { industries } from '../data/mock';
import { CheckCircle2, Rocket, Target, Lock, Zap } from 'lucide-react';
import { Helmet } from "react-helmet";


const EngineeringPage = () => {
  const industry = industries[0]; // Engineering & Startup Prototypes
  
  const breadcrumbItems = [
    { label: 'HOME', path: '/' },
    { label: 'ENGINEERING' }
  ];

  return (
    <div className="page-wrapper">
      <PageHero 
        title="Engineering & Startup Prototypes"
        breadcrumbItems={breadcrumbItems}
        subtitle="Rapid iteration for innovators and product developers"
      />
      
      <section className="page-content-section">
        <div className="container-modern">
          <div className="industry-detail-layout">
            <div className="industry-detail-hero">
              <img src={industry.image} alt={industry.title} />
              <div className="industry-detail-overlay"></div>
            </div>
            
            <div className="industry-detail-content">
              <div className="industry-intro">
                <h2 className="industry-detail-title">{industry.description}</h2>
                <p className="industry-tagline-large">{industry.tagline}</p>
              </div>
              
              <div className="features-grid">
                <div className="feature-detail-card">
                  <Rocket className="feature-detail-icon" />
                  <h3>Functional Prototypes</h3>
                  <p>Test and validate your designs with fully functional prototypes that mirror production quality.</p>
                </div>
                
                <div className="feature-detail-card">
                  <Target className="feature-detail-icon" />
                  <h3>Iterative Product Testing</h3>
                  <p>Rapid iteration cycles to refine your product based on real-world testing and feedback.</p>
                </div>
                
                <div className="feature-detail-card">
                  <Zap className="feature-detail-icon" />
                  <h3>Small Batch Validation</h3>
                  <p>Low-volume production runs for market testing and investor presentations.</p>
                </div>
                
                <div className="feature-detail-card">
                  <Lock className="feature-detail-icon" />
                  <h3>Confidential Development</h3>
                  <p>NDA-protected processes ensure your intellectual property remains secure.</p>
                </div>
              </div>
              
              <div className="capabilities-section">
                <h3 className="section-subtitle">What We Deliver</h3>
                <ul className="capabilities-list">
                  {industry.features.map((feature, idx) => (
                    <li key={idx}>
                      <CheckCircle2 className="capability-check" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
              
              <div className="process-overview">
                <h3 className="section-subtitle">Our Approach</h3>
                <p className="process-text">
                  We understand the challenges faced by startups and innovators. From initial concept sketches to investor-ready prototypes, we provide end-to-end support with transparent communication, fast turnaround times, and engineering expertise that helps you move from idea to reality.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <ContactForm />
      <Footer />
    </div>
  );
};

export default EngineeringPage;
